module.exports = __webpack_public_path__ + "img/beginShowStep4-2.837eeda2.png";